import React from "react";
import { SanityNewsArticle } from "../../model/news";
import NewsTagInfo from "../../components/NewsTagInfo/NewsTagInfo";
import TagInfo from "../TagInfo/TagInfo";
import { SanityCaseStudy, SanityFoundationReport } from "../../model/impact";
import { GlobalGoalsResourceTagInfo } from "../GlobalGoalsResourceTagInfo/GlobalGoalsResourceTagInfo";
import { SanityGlobalGoalsResource } from "../../model/dyb";

interface ArticleTagInfoProps {
  // Requires tag-relevant fields per type.
  article: { _type: string };
}

const ArticleTagInfo = ({ article }: ArticleTagInfoProps) => {
  switch (article._type) {
    case "newsArticle":
      return <NewsTagInfo article={article as SanityNewsArticle} />;
    case "globalGoalsResource":
      return (
        <GlobalGoalsResourceTagInfo
          value={article as SanityGlobalGoalsResource}
        />
      );
    case "caseStudy":
    /* Fallthrough */
    case "foundationReport":
      return (
        <TagInfo
          value={[
            [
              <span key="only">
                {
                  (article as SanityCaseStudy & SanityFoundationReport).location
                    .name
                }
              </span>
            ]
          ]}
        />
      );
    default:
      return null;
  }
};

export default ArticleTagInfo;
